export default "__VITE_ASSET__673eb25a__"